import { observer } from "mobx-react-lite";
import styled from "@emotion/styled";
import { TitleIcon } from "@/components/item-list/types";
import { MDSIcon, MDSTooltip, MDSTooltipPlacement, MDSTooltipTrigger } from "@/mds";

interface ItemListTitleIconProps {
  titleIcon: TitleIcon;
}

export const ItemListTitleIcon = observer(({ titleIcon }: ItemListTitleIconProps) => {
  const { tooltip, kind, color } = titleIcon;

  if (!tooltip) {
    return (
      <Wrapper>
        <MDSIcon kind={kind} size={12} color={color} />
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <MDSTooltip
        config={{
          label: tooltip,
          placement: MDSTooltipPlacement.Top,
        }}
      >
        <MDSTooltipTrigger>
          <MDSIcon kind={kind} size={12} color={color} />
        </MDSTooltipTrigger>
      </MDSTooltip>
    </Wrapper>
  );
});

const Wrapper = styled.span(({ theme }) => ({
  marginLeft: theme.spacing["1"],
  fontSize: theme.fontSizes["text-xs"],
  fontWeight: theme.fontWeights.regular,
  lineHeight: theme.lineHeights["text-xs"],
  color: theme.colors.icon.primary,
}));
